<script>
import { nextTick } from 'vue'

export default {
    name: "MessageBoxQuestion",

    props: {
        yesButtonText: {
            type: String,
            default: 'Ano'
        },
        noButtonText: {
            type: String,
            default: 'Ne'
        },
        text: {
            type: String,
            default: ''
        },
        type: {
            type: Number,
            default: -1
        },
        data: {
            type: Object,
            default: () => { return null }
        }
    },

    emits: ['form-closed'],

    async mounted() {
        await nextTick()
        document.getElementById('messageBoxQuestion').focus()
    },
    
    methods: {
        // Helpers
        stopEnterPropagation() {
            // dummy to stop click propagation upwards in hierarchy            
        },

        async answer(value) {
            if (value === 0) {
                this.$emit('form-closed', 0, this.type, this.data)
            }
            else {
                this.$emit('form-closed', -1, this.type)
            }
        },
        handleFormKeyDown(event) {
            if (event.key === 'Escape') {
                this.answer(-1)
            }

            if (event.key === 'Enter') {
                this.answer(0)
            }
        }
    }
}
</script>


<template>
    <div class="message-box">
        <div id="messageBoxQuestion" @keydown="handleFormKeyDown" tabindex="-1">
            <div>{{ text }}</div>

            <div class="message-box-buttons">
                <button class="button-small" @click="answer(0)">{{ yesButtonText }}</button>
                <button class="button-small" @click="answer(-1)">{{ noButtonText }}</button>
            </div>
        </div>
    </div>
</template>